import { useTranslation } from 'react-i18next'

import styles from './BuildingsTab.module.scss'

const BuildingsTab = ({ buildings, setEditingBuilding }) => {
  const { t } = useTranslation('common')

  return (
    <>
      <div className={styles.toolbar}>
        <button
          className="unv-btn unv-btn--primary"
          onClick={() => setEditingBuilding({ is_active: true, capacity: 0 })}
        >
          {t('dorm.add_building')}
        </button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{t('dorm.col_name')}</th>
            <th>{t('dorm.col_address')}</th>
            <th>{t('dorm.col_capacity')}</th>
            <th>{t('dorm.col_rooms')}</th>
            <th>{t('dorm.col_settled')}</th>
            <th>{t('dorm.col_manager')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {buildings.map((b) => (
            <tr key={b.id}>
              <td>{b.name}</td>
              <td>{b.address || '—'}</td>
              <td>{b.capacity}</td>
              <td>{b.rooms_count}</td>
              <td>{b.occupied_count}</td>
              <td>{b.manager_label || '—'}</td>
              <td>
                <button className={styles.smallBtn} onClick={() => setEditingBuilding(b)}>
                  {t('dorm.edit_short')}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default BuildingsTab
